import { IS_MODAL_OPEN } from './types';
export const handleModalStateAction = (data) => {
    return{
      type: IS_MODAL_OPEN,
      payload: data
    }
  };
  